/* eslint-disable no-mixed-spaces-and-tabs */
import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { thousandSeparator } from '../reqs-filter/utils';

export const selectOrdersContainerDomain = state => state.ordersContainerReducer || initialState;

export const selectRouterDomain = state => state.router || {};

export const getIsOrdersListLoadingSelector = () =>
	createSelector(selectOrdersContainerDomain, ({ isOrdersListLoading }) => isOrdersListLoading);

export const getOrdersListSelector = () =>
	createSelector(selectOrdersContainerDomain, ({ ordersList }) => {
		if (!ordersList || ordersList.length === 0) {
			return [];
		}

		return ordersList.map(order => ({
			...order,
			number: order.number || '',
			region_from: order.points[0]?.address?.region_with_type || '',
			address_from: order.points[0]?.address || '',
			region_to: order.points[1]?.address?.region_with_type || '',
			address_to: order.points[1]?.address || '',
			cost: order.cost ? `${thousandSeparator(order.cost)} руб` : '',
		}));
	});

export const getPaginationSelector = () =>
	createSelector(selectOrdersContainerDomain, ({ pagination }) => {
		if (!pagination || pagination?.total === 0) {
			return null;
		}

		return {
			currentPage: pagination.current_page,
			totalPages: pagination.last_page,
			perPage: pagination.per_page,
			total: pagination.total,
			from: pagination.current_page * pagination.per_page - (pagination.per_page - 1),
			to:
				pagination.current_page === pagination.last_page
					? pagination.total
					: pagination.current_page * pagination.per_page,
			isNextItem: true,
			isPrevItem: true,
			isLastItem: false,
			isFirstItem: false,
		};
	});

export const getModesSelector = () => createSelector(selectOrdersContainerDomain, ({ modes }) => modes);

export const getIsModesLoadingSelector = () =>
	createSelector(selectOrdersContainerDomain, ({ isModesLoading }) => isModesLoading);

export const getGroupsSelector = () => createSelector(selectOrdersContainerDomain, ({ groups }) => groups);

export const getIsGroupsLoadingSelector = () =>
	createSelector(selectOrdersContainerDomain, ({ isGroupsLoading }) => isGroupsLoading);

export const getIsDraftSelector = () =>
	createSelector(selectRouterDomain, ({ location: { pathname } }) => {
		return Boolean(pathname.endsWith('_draft'));
	});
